'use client';

import * as React from 'react';
import { styled } from '@linaria/react';

import IconBomb from './IconBoopDemo/IconBomb';

const MAIN_COLOR = 'hsl(350deg 100% 50%)';
const FUSE_COLOR = 'hsl(180deg 100% 40%)';

function BombPivotDiagram() {
  return (
    <Wrapper
      style={{
        '--color-main': MAIN_COLOR,
        '--color-fuse': FUSE_COLOR,
      }}
    >
      <BombWrapper>
        <IconBomb
          size={130}
          includePivotPoints
          mainPivotColor={MAIN_COLOR}
          fusePivotColor={FUSE_COLOR}
        />
      </BombWrapper>
      <MainLine />
      <FuseLine />
      <MainLabel>Main pivot point</MainLabel>
      <FuseLabel>Fuse pivot point</FuseLabel>
    </Wrapper>
  );
}

function MainLine() {
  return (
    <MainSvg
      width="79"
      height="74"
      viewBox="0 0 79 74"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 2.08341C27 -0.799743 20 72 77 72"
        stroke="var(--color-main)"
        strokeWidth="4"
        strokeLinecap="round"
      />
    </MainSvg>
  );
}

function FuseLine() {
  return (
    <FuseSvg
      width="161"
      height="47"
      viewBox="0 0 161 47"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="none"
    >
      <path
        d="M2 2.5C15.5 41.5 141.045 5.74074 159 45"
        stroke="var(--color-fuse)"
        strokeWidth="4"
        strokeLinecap="round"
      />
    </FuseSvg>
  );
}

const Wrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  width: 550px;
  max-width: 100%;
  margin-inline: auto;
  margin-top: 2rem;
  margin-bottom: 4rem;
  padding: 16px;
  padding-block: 32px;
  border-radius: 8px;
`;

const BombWrapper = styled.div`
  --col-width: 11px;
  --col-border-width: 2px;
  --col-space: calc(var(--col-width) - var(--col-border-width));

  display: flex;
  justify-content: center;
  border: 2px solid var(--color-gray-200);
  border-radius: 4px;
  background: repeating-linear-gradient(
      180deg,
      transparent 0px var(--col-space),
      var(--color-gray-200) var(--col-space) var(--col-width)
    ),
    repeating-linear-gradient(
      90deg,
      transparent 0px var(--col-space),
      var(--color-gray-200) var(--col-space) var(--col-width)
    );
`;

const MainSvg = styled.svg`
  position: absolute;
  top: 20%;
  right: calc(50% + 16px);
`;
const FuseSvg = styled.svg`
  position: absolute;
  top: 34%;
  left: calc(50% + 37px);
  width: 29.27%;
  height: 47px;

  @media (max-width: 28.125rem) {
    top: 33%;
    left: calc(50% + 37px);
    width: 33%;
  }
`;

const Label = styled.div`
  position: absolute;
  font-size: 1.325rem;
  font-weight: var(--font-weight-medium);
`;

const MainLabel = styled(Label)`
  top: 22px;
  left: 12px;
  max-width: 160px;

  @media (max-width: 38rem) {
    max-width: 120px;
    left: 15%;
    top: 0;
  }
  @media (max-width: 30rem) {
    left: 0;
  }
`;

const FuseLabel = styled(Label)`
  top: 57%;
  right: 11px;
  text-align: right;

  @media (max-width: 38rem) {
    max-width: 120px;
  }
`;

export default BombPivotDiagram;
